import Currency from "./currency";
import Money from "./money";

export default class AppointmentCard {
  #ui;
  #details;
  #timezone;

  get eventTarget() {
    return this.#ui.selected.card;
  }

  init(timezone) {
    this.#timezone = timezone;
    this.#cacheUiElements();
    this.#bindEvents();
  }

  select(appointment) {
    this.#details = {
      id: appointment.id,
      deposit: appointment.treatment.deposit.value,
      note: "",
    };

    this.#updateUi(appointment);
  }

  deselect() {
    this.#details = {
      id: -1,
      deposit: 0,
      note: "",
    };

    this.#clearUi();
  }

  #updateUi({ start, provider, treatment }) {
    const tzStart = moment.tz(start, this.#timezone);
    const date = tzStart.format("ddd DD/MM/YYYY");
    const time = tzStart.format("h:mm a");

    if (treatment.price.value > 0) {
      this.#showPrice(treatment);
    }
    else {
      this.#hidePrice();
    }

    if (treatment.deposit.value > 0) {
      this.#showDeposit(treatment);
    }
    else {
      this.#hideDeposit();
    }

    this.#ui.selected.date.text(date);
    this.#ui.selected.time.text(time);
    this.#ui.selected.provider.text(provider.fullName);
    this.#ui.selected.type.text(treatment.description);

    if (provider.photographUrl) {
      this.#showPhotograph(provider.photographUrl);
    }
    else {
      this.#hidePhotograph();
    }

    // Display the appointment card and scroll to it (if not disabled)
    this.#ui.selected.card.removeClass("hidden");
    this.#ui.notSelected.card.addClass("hidden");

    window.scroller.scrollToElemTop(this.#ui.selected.card);
  }

  #showPhotograph(url) {
    this.#ui.selected.providerImg.attr("src", url);
    this.#ui.selected.imgContainer.removeClass("hidden");
  }
  #hidePhotograph() {
    // An empty data url is used for the src when there is no image to show
    this.#ui.selected.providerImg.attr("src", "data:,");
    this.#ui.selected.imgContainer.addClass("hidden");
  }

  #showPrice(treatment) {
    const currency = new Currency(treatment.price.currencySymbol, treatment.price.currencyCode);

    const price = new Money(currency);
    price.value = treatment.price.originalValue;

    const newPrice = new Money(currency);
    newPrice.value = treatment.price.value;

    // If the new price is greater or equal to the original price the display it as the standard price
    if (newPrice.value >= price.value) {
      this.#ui.selected.price.text(newPrice.getDisplayString());
    }
    else {
      // Otherwise display the price as a discount to the original price
      const cleanPrice = DOMPurify.sanitize(price.getDisplayString());
      const cleanDiscount = DOMPurify.sanitize(newPrice.getDisplayString());
      let $discount = $(`<span>${cleanDiscount}&nbsp;<span class="old-price">Was:&nbsp<span class="text-decoration-line-through">${cleanPrice}</span></span>`);

      this.#ui.selected.price.html($discount);
    }

    this.#ui.selected.priceContainer.removeClass("hidden");
  }
  #hidePrice() {
    this.#ui.selected.price.text("-");
    this.#ui.selected.priceContainer.addClass("hidden");

    // Can't calculate outstanding amount if no price given
    this.#ui.selected.outstanding.text("-");
    this.#ui.selected.outstandingContainer.addClass("hidden");
  }

  #showDeposit(treatment) {
    const currency = new Currency(treatment.deposit.currencySymbol, treatment.deposit.currencyCode);
    const deposit = new Money(currency);
    deposit.value = treatment.deposit.value;

    this.#ui.selected.deposit.text(deposit.getDisplayString());

    this.#ui.selected.depositContainer.removeClass("hidden");
    this.#ui.selected.noDepositContainer.addClass("hidden");

    // Show outstanding amount if the full price is given
    // and it can be calculated
    if (treatment.price.value > 0) {
      const outstanding = new Money(currency);
      outstanding.value = treatment.price.value - deposit.value;

      this.#ui.selected.outstanding.text(outstanding.getDisplayString());
      this.#ui.selected.outstandingContainer.removeClass("hidden");
    }
  }
  #hideDeposit() {
    this.#ui.selected.deposit.text("-");
    this.#ui.selected.outstanding.text("-");
    this.#ui.selected.depositContainer.addClass("hidden");
    this.#ui.selected.noDepositContainer.removeClass("hidden");
  }

  #clearUi() {
    this.#ui.selected.date.text("");
    this.#ui.selected.time.text("");
    this.#ui.selected.provider.text("");
    this.#ui.selected.type.text("");
    this.#ui.selected.price.text("");
    this.#ui.selected.deposit.text("");
    this.#ui.selected.outstanding.text("");
    this.#ui.selected.note.text("");

    // Hide the appointment card
    this.#ui.selected.card.addClass("hidden");
    this.#ui.notSelected.card.removeClass("hidden");
  }

  #cacheUiElements() {
    this.#ui = {
      notSelected: {
        card: $("#appointment-not-selected.card"),
      },
      selected: {
        card: $("#appointment-selected.card"),
        date: $(".appointment-date"),
        time: $(".appointment-time"),
        provider: $(".appointment-provider"),
        providerImg: $("#appointment-selected img"),
        imgContainer: $("#appointment-selected .img-container"),
        type: $(".appointment-type"),
        priceContainer: $(".price-container"),
        price: $(".appointment-price"),
        depositContainer: $(".deposit-container"),
        deposit: $(".appointment-deposit"),
        outstandingContainer: $(".outstanding-container"),
        outstanding: $(".appointment-outstanding"),
        noDepositContainer: $(".no-deposit-container"),
        note: $(".appointment-note"),
        confirmButton: $("#btn-confirm-appointment"),
      },
    };
  }

  #bindEvents() {
    this.#ui.selected.confirmButton.click(() => {
      this.#details.note = this.#ui.selected.note.val();
      this.eventTarget.triggerHandler("confirm.appointment-card", this.#details);
    });
  }
}
